import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
export var StopSVG = function StopSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    d: "M26.833 3H5.167A2.173 2.173 0 0 0 3 5.167v21.666C3 28.025 3.975 29 5.167 29h21.666A2.173 2.173 0 0 0 29 26.833V5.167A2.173 2.173 0 0 0 26.833 3z",
    stroke: "none"
  }));
};
StopSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(StopSVG);